/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import styled from "styled-components";

import {colors} from "nxtconstants";

const LatestBlogs = ({
  latestBlogs
}) => {
  return (
    <RelatedPosts>
      <RelatedPostsTitle>
        Latest Blogs
      </RelatedPostsTitle>
      <RelatedPostsList>
        {
          latestBlogs.map((blogItem, index) => (
            <PostLink
              href={blogItem.url}
              key={index}
            >
              {blogItem.title}
            </PostLink>
          ))
        }
      </RelatedPostsList>
    </RelatedPosts>
  );
};


const RelatedPosts = styled.div``;

const RelatedPostsTitle = styled.h2`
  color: ${colors.textGray};
  font-size: 1.8rem;
`;

const RelatedPostsList = styled.div`
  border-radius: 20px;
  border: 1px solid #DCDCDC;
  border-radius: 0.8rem;
  overflow: hidden;
  margin-top: 1.7rem;
`;

const PostLink = styled.a`
  color: ${colors.textBlack};
  padding: 1.6rem 2rem;
  font-size: 1.55rem;
  display: block;

  &:not(:last-child) {
    border-bottom: 1px solid #DCDCDC;
  }

  &:hover {
    background-color: ${colors.athensGrayLight};
  }
`;

export default LatestBlogs;
